import { ApiResponse } from 'apisauce';
import { restApi } from '../../api';
import { GetInvitesCountOutput } from './invites.types';

export const getInvitesCount = (): Promise<ApiResponse<GetInvitesCountOutput>> =>
  restApi.get<GetInvitesCountOutput>('/invites/count');
